var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBolepix(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.000118091 25.1519V0H25.5518V25.1519H0.000118091ZM1.63805 23.5186H23.9139V1.63322H1.63805V23.5186ZM0 56.8367L0.000118091 31.6848H25.5517V56.8367H0ZM1.63793 55.2035H23.9137V33.3181H1.63793V55.2035ZM31.4483 25.1519V0H57V25.1519H31.4483ZM33.0863 23.5186H55.3621V1.63324H33.0863V23.5186ZM50.5029 57V50.6848H56.8362V57H50.5029ZM31.5029 38.0544V31.7392H37.8362V38.0544H31.5029ZM37.8362 44.3696V38.0544H44.1696V44.3696H37.8362ZM31.5029 50.6848V44.3696H37.8362V50.6848H31.5029ZM37.8362 57V50.6848H44.1696V57H37.8362ZM44.1696 50.6848V44.3696H50.5029V50.6848H44.1696ZM44.1696 38.0544V31.7392H50.5029V38.0544H44.1696ZM50.5029 44.3696V38.0544H56.8362V44.3696H50.5029Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolepix);
export default __webpack_public_path__ + "static/media/bolepix.fab953de65ef99cf42cdad128d022ae0.svg";
export { ForwardRef as ReactComponent };